import { render, staticRenderFns } from "./NewCalendar.vue?vue&type=template&id=aca5933e&scoped=true&"
import script from "./NewCalendar.vue?vue&type=script&lang=js&"
export * from "./NewCalendar.vue?vue&type=script&lang=js&"
import style0 from "./NewCalendar.vue?vue&type=style&index=0&id=aca5933e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5933e",
  null
  
)

export default component.exports